import { useState, useEffect } from "react";
import { Star, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { useContent } from "@/context/ContentContext";
import { pushEvent } from "@/lib/api";

const LINKS = [
  { label: "Home", href: "#top" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Services", href: "#services" },
  { label: "Areas", href: "#areas" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { content } = useContent();
  const phone = content.phone || "(310) 508-6563";
  const telHref = `tel:${phone.replace(/[^0-9+]/g, "")}`;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#FFFBF5]/90 backdrop-blur-xl shadow-sm" : "bg-[#FFFBF5]/60 backdrop-blur-md"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-8">
        <a href="#top" className="shrink-0" aria-label="ColorStone Home Painting — home">
          <Logo />
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="rounded-md px-3 py-2 text-base font-semibold text-[#1E293B] transition-colors hover:text-[#2563EB]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden items-center gap-1.5 rounded-full bg-white px-3 py-1.5 md:flex">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 text-[#F59E0B]" fill="#F59E0B" />
              ))}
            </div>
            <span className="text-sm font-bold text-[#0F172A]">4.9</span>
          </div>
          <a
            href={telHref}
            onClick={() => pushEvent("PaintingCall", { phone, location: "header" })}
            data-testid="nav-call-btn"
            className="phoneLink flex items-center gap-1.5 whitespace-nowrap rounded-full bg-[#2563EB] px-3.5 py-2.5 text-sm font-bold text-white shadow-lg shadow-[#2563EB]/30 transition-transform duration-200 hover:bg-[#1D4ED8] hover:scale-105 sm:gap-2 sm:px-5 sm:text-base"
          >
            <Phone className="h-4 w-4" fill="white" />
            <span>{phone}</span>
          </a>
        </div>
      </div>
    </header>
  );
}
